// extracted by mini-css-extract-plugin
module.exports = {"select":"ExchangesListDropdownMenu_select__1DV1Z","exchange":"ExchangesListDropdownMenu_exchange__3plC5","symbolIcon":"ExchangesListDropdownMenu_symbolIcon__3yrkZ"};